module.exports = __webpack_public_path__ + "static/media/telegram.fb037bbf.png";